import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { isUndefined } from "lodash";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";

const phoneNumberUtil = PhoneNumberUtil.getInstance();

export function validatePhone(
  phone: {
    phone: string;
    countryCode?: string;
  },
  bootstrapService: BootstrapService
): boolean {
  try {
    if (!phone.phone) {
      return false;
    }

    if (phone.countryCode) {
      phone.phone = `+${getPrefixPhoneByCountryCode(
        phone.countryCode
      )}${getPhoneNumber(phone.phone, bootstrapService, phone.countryCode)}`;
    }

    const phoneNumber: libphonenumber.PhoneNumber | null = parsePhoneNumber(
      phone.phone,
      bootstrapService
    );

    return !phoneNumber ? false : phoneNumberUtil.isValidNumber(phoneNumber);
  } catch (ex) {
    return false;
  }
}

export function buildPhoneNumberWithPrefix(
  phone: {
    phone: string;
    countryCode?: string;
  },
  bootstrapService: BootstrapService
): string {
  if (!phone.phone) {
    return "";
  }

  if (phone.countryCode) {
    return `+${getPrefixPhoneByCountryCode(phone.countryCode)}${getPhoneNumber(
      phone.phone,
      bootstrapService,
      phone.countryCode
    )}`;
  }
  return `+${getPrefixPhone(phone.phone, bootstrapService)}${getPhoneNumber(
    phone.phone,
    bootstrapService
  )}`;
}

export function getDefaultPrefixPhone(
  bootstrapService: BootstrapService
): string {
  return bootstrapService.getCurrentTenant()!.region;
}

export function getPrefixPhone(
  phone: string,
  bootstrapService: BootstrapService
): string {
  if (!phone) {
    return "";
  }

  const result: libphonenumber.PhoneNumber | null = parsePhoneNumber(
    phone,
    bootstrapService
  );

  if (!result) {
    return phone;
  }

  const res = result as libphonenumber.PhoneNumber;

  // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
  return res.getCountryCode().toString();
}

export function getPhoneNumber(
  phone: string,
  bootstrapService: BootstrapService,
  countryCode?: string
): string {
  if (!phone) {
    return "";
  }

  const result: libphonenumber.PhoneNumber | null = parsePhoneNumber(
    phone,
    bootstrapService
  );

  if (!result) {
    return phone;
  }

  if (!isUndefined(countryCode)) {
    result.setCountryCode(parseInt(countryCode));
  }

  const res = result as libphonenumber.PhoneNumber;

  return phoneNumberUtil
    .format(res, PhoneNumberFormat.NATIONAL)
    .replaceAll(" ", "");
}

export function getRegionCodePhoneNumber(
  phone: string,
  bootstrapService: BootstrapService
): string {
  if (!phone) {
    return "";
  }

  let phoneNumber = parsePhoneNumber(phone, bootstrapService);

  return !phoneNumber
    ? phone
    : // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
      phoneNumberUtil.getRegionCodeForNumber(
        phoneNumber as libphonenumber.PhoneNumber
      );
}

export function getPrefixPhoneByCountryCode(countryCode: string): string {
  if (!countryCode) {
    return "";
  }
  return phoneNumberUtil
    .getCountryCodeForRegion(countryCode.toUpperCase())
    .toString();
}

function parsePhoneNumber(
  value: string,
  bootstrapService: BootstrapService
): libphonenumber.PhoneNumber | null {
  try {
    return phoneNumberUtil.parse(value);
  } catch (error) {
    try {
      return phoneNumberUtil.parse(
        value,
        getDefaultPrefixPhone(bootstrapService)
      );
    } catch (e) {
      return null;
    }
  }
}
